import axios from 'axios';
import { tecDocUrl, PROVIDER_ID, basicAuth } from 'utils/constantsHelper';
import { langCode } from 'utils/currentLanguage';

const headers = {
  countryGroupFlag: false,
  provider: PROVIDER_ID,
};

export const getCarDetails = (cars, articleCountry, vehicleType) => {
  return axios.post(
    tecDocUrl,
    {
      getVehicleByIds4: {
        ...headers,
        carIds: {
          array: cars,
        },
        motorCodes: true,
        articleCountry: articleCountry,
        lang: langCode,
        country: articleCountry,
        countriesCarSelection: articleCountry,
        carType: vehicleType,
      },
    },
    { headers: basicAuth }
  );
};

export const getCarAutosuggestions = (
  articlesHeaders,
  articleCountry,
  vehicleType
) => {
  return axios.post(
    tecDocUrl,
    {
      getVehicleIdsByCriteria: {
        ...articlesHeaders,
        ...headers,
        country: articleCountry,
        countriesCarSelection: articleCountry,
        articleCountry: articleCountry,
        lang: langCode,
        carType: vehicleType,
      },
    },
    { headers: basicAuth }
  );
};

export const getCarManufactures = (articleCountry, vehicleType) => {
  return axios.post(
    tecDocUrl,
    {
      getManufacturers: {
        countryGroupFlag: false,
        lang: langCode,
        linkingTargetType: vehicleType,
        country: articleCountry,
        provider: PROVIDER_ID,
      },
    },
    { headers: basicAuth }
  );
};

export const getCarModels = (manuId, articleCountry, vehicleType, configs) => {
  return axios.post(
    tecDocUrl,
    {
      getModelSeries: {
        countryGroupFlag: false,
        lang: langCode,
        linkingTargetType: vehicleType,
        manuId: manuId,
        country: articleCountry,
        provider: PROVIDER_ID,
      },
    },
    { headers: basicAuth, ...configs }
  );
};



// WEBPACK FOOTER //
// ./src/utils/getCarAutosuggestions.js